import type { Channel } from "../../shared/types";

interface ChannelFilterOptions {
  favoriteIds?: ReadonlySet<string>;
  favoritesOnly?: boolean;
}

export function filterAndPrioritizeChannels(channels: Channel[], query: string, options: ChannelFilterOptions = {}): Channel[] {
  const normalizedQuery = query.trim().toLowerCase();
  const queryFiltered = normalizedQuery
    ? channels.filter((channel) =>
        [channel.name, channel.group, channel.tvgId, channel.id]
          .filter(Boolean)
          .some((value) => value!.toLowerCase().includes(normalizedQuery))
      )
    : channels;
  const filtered = options.favoritesOnly
    ? queryFiltered.filter((channel) => options.favoriteIds?.has(channel.id))
    : queryFiltered;

  return [...filtered].sort((left, right) => priority(right, options.favoriteIds) - priority(left, options.favoriteIds));
}

function priority(channel: Channel, favoriteIds: ReadonlySet<string> = new Set()): number {
  const favoritePriority = favoriteIds.has(channel.id) ? 10 : 0;
  const tvriPriority = /tvri\s*sport/i.test(channel.name) || /TVRISport/i.test(channel.id) ? 1 : 0;
  return favoritePriority + tvriPriority;
}
